import React, {useContext, useState} from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {useAuth} from "../../../hooks/useAuth";
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {NotificationType} from "../../../constants/global";
import {ToasterContext} from "../../shared/Toaster/ToasterContext";
import {CircularProgress} from "@mui/material";

interface IConfirmSignUpProps {
  setIsConfirmed: (confirmed: boolean) => void,
}

const ConfirmEmail: React.FunctionComponent<IConfirmSignUpProps> = ({
  setIsConfirmed,
}) => {
  const {addToast} = useContext(ToasterContext);
  const auth: any = useAuth();
  const navigate  = useNavigate();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState<boolean>(false);

  const validationSchema = Yup.object().shape({
    code: Yup.string()
      .required('Code Required'),
  });

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(validationSchema)
  });

  const handleOnChange = (res: string) => {
    setCode(res);
  };

  const confirmEmail = async () => {
    setLoading(true);
    const result = await auth.verifyEmailUpdate(code);

    if (result.success) {
      setLoading(false);
      setIsConfirmed(false);
      addToast({ type: NotificationType.Success, title: 'Your account has been successfully confirmed.'  });
      navigate ('/');
    } else {
      setLoading(false);
      setIsConfirmed(true);
      addToast({ type: NotificationType.Error, title: result.message  });
    }
  }

  return (
    <>
      <Typography component="h1" variant="h5">
        Verify Code
      </Typography>
      <Box sx={{mt: 2}} component="form" onSubmit={handleSubmit(confirmEmail)} noValidate>
        <TextField
          margin="normal"
          required
          fullWidth
          id="code"
          label="Verify Code"
          autoComplete="code"
          helperText={errors.code?.message?.toString()}
          {...register('code')}
          error={!!errors.code}
          autoFocus
          onChange={(event)=>handleOnChange(event.currentTarget.value)}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{mt: 3, mb: 2}}
        >
          Verify
          { loading && <CircularProgress sx={{ml: 1}} size={14} color='inherit' />}
        </Button>
      </Box>
    </>
  );
}

export default ConfirmEmail;